export default function(instance){
    return{
        getByReportTypeId(payload){
            return instance.get('/ReportTypeFilterType/' + payload.reportTypeId);
        }
    }
}
